import React from 'react';
import PropTypes from 'prop-types';
import R from 'ramda';
import Heading from '@cotyorg/ccx-atoms/Heading';
import Paragraph from '@cotyorg/ccx-atoms/Paragraph';
import { HeroFullBlock } from '@cotyorg/ccx-organism-hero';
import SectionHeader from '../../../../atoms/SectionHeader';

export const Facts = ({ sectionHeadings, section }) => (
  <div className="facts-section">
    <div className="facts-section__hero">
      <HeroFullBlock
        heroStoreDataKey={section}
        isContentFirst
        isUnderlined={false}
      />
    </div>
    {R.path([{ section }, 'heading'])(sectionHeadings) && (
      <div className="facts-section__icons grid-container">
        <div className="grid-x grid-margin-x">
          <div className="cell">
            <SectionHeader>
              <Heading extraClass="section__title" level={2}>
                {R.path([{ section }, 'heading'])(sectionHeadings)}
              </Heading>

              <Paragraph>
                {R.path([{ section }, 'introduction'])(sectionHeadings)}
              </Paragraph>
            </SectionHeader>
          </div>
        </div>
      </div>
    )}
  </div>
);

Facts.propTypes = {
  sectionHeadings: PropTypes.instanceOf(PropTypes.object),
  section: PropTypes.string,
};
